<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Royalty">
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-card-title>
              Total Records : {{ total }}
              <v-spacer></v-spacer>
            </v-card-title>
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search"
              append-icon="mdi-magnify"
              class="ml-auto mb-2"
              label="Search"
              hide-details
              single-line
              style="max-width:350px;"
            />
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :search.sync="search"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
            :headers="headers"
            :items="searchFilterArray"
          >
            <template v-slot:item.dateOFAdmission="{ item }">
              {{ new Date(item.studentEnrollment.dateOFAdmission).toLocaleDateString() }}
            </template>
             <template v-slot:item.gender="{ item }">
              {{ item.studentEnrollment.gender === 'MALE' || item.studentEnrollment.gender ==='Male' ? 'Boy' :item.studentEnrollment.gender ==='FEMALE' ||item.studentEnrollment.gender ==='Female' ? 'Girl':item.studentEnrollment.gender  }}
            </template>

            <template v-slot:item.actions="{ item }">
              <router-link :to="{ name: 'StudentroyaltyList', params: { StudentAdmissionID: item.id, franchiseeNo: franchiseeID } }">
                <v-btn class="px-2 ml-1 ma-1" min-width="0" small>
                  <v-icon small color="black"> mdi-eye </v-icon>
                </v-btn>
              </router-link>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
      </material-card>
      </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import constants from '@/utils/constants'
// import helper from '@/utils/helper'
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'royalty',
  components: {
    MaterialCard
  },

  data () {
    return {
      searchTerm: '',
      search: '',
      data: [],
      searchFilterArray: [],
      inProgress: false,
      franchiseeArr: [],
      franchiseeID: '',
      paginated: false,
      perPage: 10,
      total: '',
      headers: [
        { text: 'Student Name', value: 'studentEnrollment.studentName', sortable: true },
        { text: 'Class', value: 'class', sortable: true },
        { text: 'Section', value: 'section', sortable: true },
        { text: 'Gender', value: 'gender', sortable: true },
        { text: 'Admission Date', value: 'dateOFAdmission', sortable: true },
        { text: 'B2B Enrollment', value: 'studentEnrollment.enrollmentCode', sortable: true },
        { text: 'MCB Enrollment', value: 'studentEnrollment.enrollmentNoMCB', sortable: true },
        { text: 'Action', value: 'actions', sortable: true, align: 'center' }
      ],

      loadingComponent: null
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  watch: {
    franchisee: function (val) {
      if (val) {
        this.onFranchiseeChange()
      }
    }
  },
  methods: {
    onFranchiseeChange: async function () {
      try {
        if (!this.inProgress) {
          this.inProgress = true
          if (this.franchisee) {
            this.franchiseeID = this.franchisee.id
            await this.getRoyaltyList()
          } else {
            this.franchiseeID = ''
            this.data = []
            this.total = 0
            return
          }
        }
      } finally {
        this.inProgress = false
      }
    },
    getRoyaltyList: async function () {
      try {
        console.log(this.franchiseeID, this.franchisee)
        const response = await http.get(`${constants.API_URL}/api/students/${this.franchiseeID}`)

        if (response.data.rows) {
          this.data = response.data.rows
          this.searchFilterArray = this.data
          this.total = this.data.length
          this.paginated = !!this.total
        } else {
          this.data = []
          this.searchFilterArray = this.data
          this.total = 0
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching ', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
      }
    },

    customSearch: async function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.data
        this.total = this.data.length
      } else {
        this.searchFilterArray = _.filter(
          this.data,
          item =>
            (item && item.studentEnrollment && item.studentEnrollment.studentName.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.studentEnrollment && item.studentEnrollment.dateOFAdmission.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.studentEnrollment && item.studentEnrollment.enrollmentNoMCB.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.studentEnrollment && item.studentEnrollment.enrollmentCode.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.class.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.section.toLowerCase().search(value.toLowerCase()) >= 0) ||
            (item && item.studentEnrollment && item.studentEnrollment.gender.toLowerCase().search(value.toLowerCase()) >= 0)
        )

        this.total = this.searchFilterArray.length
      }
    }
  }
}
</script>
